module.exports = __webpack_public_path__ + "img/font.1205cdab.png";